import type { AlpineComponent } from 'alpinejs'
import Swiper from 'swiper'
import { Pagination, Navigation, A11y, EffectFade } from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'
import 'swiper/css/bundle'
import 'swiper/css/pagination'

// if better types get needed check
// https://github.com/alpinejs/alpine/issues/2199#issuecomment-1809892127

export function Slider(config: SwiperOptions): AlpineComponent<{
  swiper: Swiper | undefined
  init(): void
  discard(): void
}> {
  const defaultConfig: SwiperOptions = {
    modules: [Pagination, Navigation, A11y, EffectFade],
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    pagination: {
      el: this.$refs.pagination,
      type: 'progressbar',
    },
    navigation: {
      nextEl: this.$refs.next,
      prevEl: this.$refs.prev,
      disabledClass: 'opacity-50 cursor-not-allowed',
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
  }

  return {
    swiper: undefined,

    init() {
      this.swiper = new Swiper(this.$refs.slider, {
        ...defaultConfig,
        ...config,
        on: {
          slideChange: () => {
            if (this.swiper) {
              this.$refs.counter.textContent = `${this.swiper.realIndex + 1}`
            }
          },
        },
      })
    },

    discard() {
      this.swiper && this.swiper.destroy()
    },
  }
}
